<div *ngIf="control" class="flex date-time-input">
    <mat-form-field appearance="fill" class="width-auto" *ngIf="dateControl" (click)="picker.open()" [class.mat-focused]="picker.opened">
        <mat-label>{{ placeholder }}
            <ng-container *ngIf="required"> *</ng-container>
        </mat-label>
        <input matInput
               [readonly]="true"
               [matDatepicker]="picker"
               [formControl]="dateControl"
               [attr.required]="required"
               [errorStateMatcher]="matcher"
               [min]="minDate"
               (dateChange)="onChanged()"
               [id]="id + '-date'">
        <span matSuffix class="icon icon-calendar"></span>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="control.hasError('required')">
            {{ 'ERRORS.FIELD_IS_REQUIRED' | translate }}
        </mat-error>
        <mat-error>
            <ng-content></ng-content>
        </mat-error>
        <mat-hint *ngIf="hint" class="{{ hintClass }}">
            {{ hint }}
        </mat-hint>
    </mat-form-field>
    <app-select
        [control]="timeControl"
        [options]="times"
        [placeholder]="'LABELS.AT'"
        [required]="true"
        [id]="id + '-time'"
        [icon]="'icon-clock'"
        (selected)="onSelectChange($event)"
    >
    </app-select>
</div>
